module.exports = __webpack_public_path__ + "assets/img/16_1653_big.7c621c58.jpg";